module.exports = __webpack_public_path__ + "static/media/looping-logo.484cc173.svg";